export const dashboardInitialCode = `// For Velo API Reference documentation visit http://wix.to/94BuAAs
import wixDashboard from 'wix-dashboard';

$w.onReady(function () {
	// Initialize your dashboard here.
\t
});
`
